export const posts = [
  {
    slug: "building-a-multi-phase-ai-interview-platform",
    title: "Building a Multi-Phase AI Interview Platform",
    date: "2026-06-15",
    excerpt: "Notes on designing an AI interview platform that runs candidates through voice Q&A, system design, and live coding rounds.",
    tags: ["AI", "FastAPI", "React", "System Design"],
    content: `
One of the more interesting problems I've worked on recently is building an AI-driven interview platform — the kind that runs a candidate through multiple distinct rounds (voice Q&A, system design, and live coding) instead of a single generic chatbot Q&A.

## Why multi-phase

A single-format interview doesn't tell you much about a candidate. Splitting it into phases — conversational voice screening, a system design discussion, and a hands-on coding round — mirrors how real interview loops are structured, and each phase needs a different kind of evaluation logic.

## The stack

The platform is split into separate frontend/backend services for the admin side and the candidate-facing interview side, all behind a FastAPI backend with a React frontend, containerized with Docker so each phase's environment stays isolated and easy to redeploy independently.

## What I'd do differently

Keeping the admin and candidate experiences as separate deployable services (rather than one monolith) made it much easier to iterate on the interview flow without risking the admin dashboard, and vice versa. If you're building something similar, I'd recommend starting with that separation early rather than retrofitting it later.

*This is a starter post — I'll be expanding on the evaluation/scoring side in a follow-up.*
    `.trim()
  },
  {
    slug: "measuring-rag-pipeline-quality-with-ragas",
    title: "Measuring RAG Pipeline Quality with RAGAS",
    date: "2026-05-02",
    excerpt: "How I built a RAG Evaluator to score retrieval-augmented generation pipelines against standard metrics instead of eyeballing outputs.",
    tags: ["RAG", "LangChain", "Evaluation"],
    content: `
Shipping a RAG pipeline is the easy part. Knowing whether it's actually *good* — whether it's retrieving the right context and generating grounded answers — is harder, and "it looks fine to me" doesn't scale.

## Why I built an evaluator

I built a small tool (RAG Evaluator, open source on GitHub) specifically to score RAG pipelines against standard metrics rather than relying on manual spot-checks. It's built with LangChain for the pipeline side and RAGAS for the actual evaluation metrics, wrapped in a Streamlit interface so it's usable without touching code.

## What it checks

RAGAS gives you metrics like faithfulness (is the answer actually grounded in the retrieved context?) and answer relevance, which catch a different class of bug than a typical unit test — the pipeline can run without errors and still be confidently wrong.

## Takeaway

If you're building anything RAG-based, I'd treat evaluation as part of the pipeline from day one, not something bolted on after users start complaining about hallucinated answers.

*This is a starter post — happy to go deeper on specific metrics if there's interest.*
    `.trim()
  }
];
